<template>
 <div id="rightContact">
    <div class="contact_div">
        <div onclick="chat()" class="div1">
            <img class="contact_img2" src="@/assets/images/rightContact_phone.png" alt="">
            <p>客服热线</p>
            <div class="contact_phone">
                <p style="color:#010028;font-weight: 500;">全国统一客服热线</p>
                <p style="color:#010028;font-weight: 500;">4006 - 0796 - 56</p>
            </div>
        </div>
        <div onclick="chat()" class="div2">
            <img class="contact_img3" src="@/assets/images/rightContact_weixin.png" alt=""> 
            <p>官方微信</p>
            <div class="contact_weixin">
                <img src="@/assets/images/footer_erweima1.png" alt="">
            </div>
        </div>
        <div @click="chat()" class="div3">
           <img class="contact_img1" src="@/assets/images/kefu.png" alt="">
           <p>在线留言</p>
           <!-- <div class="contact_kefu">
               <p>在线客服</p>
               <div >
                 <img src="@/assets/images/04afb78dfebd1349afe6f78bbbfe148f38b4247a1920a-0XRFya_fw1200.png"  class="img" alt="">
                   <p class="kefu" >万佶客服1</p>
                 </div>
                 <div class="kfg"></div>
                  <div >
                 <img src="@/assets/images/04afb78dfebd1349afe6f78bbbfe148f38b4247a1920a-0XRFya_fw1200.png"  class="img" alt="">
                   <p class="kefu" >万佶客服2</p>
                 </div>
                 <div class="kfg"></div>
                  <div >
                 <img src="@/assets/images/04afb78dfebd1349afe6f78bbbfe148f38b4247a1920a-0XRFya_fw1200.png"  class="img" alt="">
                   <p class="kefu" >万佶客服3</p>
                 </div>
               </div>
            </div> -->
        </div>
     
    </div>
    
 </div>
</template>

<script>

export default {
  name: "rightContact",
  components: {
  
  },
  data() {
    return {
        show: false,
    };
  },
  methods: {
    chat() {
      
    this.$router.push({path:'/contact'})
    },
  },
};
</script>


<style scoped lang="less">
#rightContact {
  &:hover{
     opacity: 1;
  }
  opacity: 0;
  width: 100px;
  height: 272px;
  .contact_div {
    height: 100%;
    padding: 22px 0px;
    > div {
      width: 80px;
      height: 82px;
      margin: auto;
      background: #0070df;
      text-align: center;
      border-radius: 5px;
      margin-bottom: 4px;
      padding-top: 16px;
      cursor: pointer;
    }
    img {
      width: 30px;
      height: 1px;
      cursor: pointer;
    }
    .contact_img1 {
      width: 32px;
      height: 32px;
    }
    p {
      font-size: 14px;
      color: #fff;
    }
    .div1 {
      &:hover .contact_phone {
        display: block !important;
      }
    }
    .div2 {
      &:hover .contact_weixin {
        display: block !important;
      }
    }
    .div3 {
      &:hover .contact_kefu {
        display: block !important;
      }
    }
    .contact_img2 {
      width: 26px;
      height: 26px;
    }
    .contact_img3 {
      width: 32px;
      height: 26px;
    }
  }
  .contact_phone {
    display: none;
    transition: all 0.3s linear 0s;
    width: 174px;
    height: 68px;
    background: url("~@/assets/images/rightContact_bac2.png") no-repeat center;
    background-size: 100% 100%;
    position: absolute;
    top: 30px;
    left: -164px;
    padding-top: 15px;
    > p {
      padding-right: 15px;
    }
  }
  .contact_weixin {
    display: none;
    transition: all 0.3s linear 0s;
    width: 174px;
    height: 168px;
    background: url("~@/assets/images/rightContact_bac.png") no-repeat center;
    background-size: 100% 100%;
    position: absolute;
    top: 64px;
    left: -164px;
    text-align: left;
    > img {
      width: 163px;
      height: 162px;
      vertical-align: text-top;
      margin-left: 2px;
    }
  }
  .contact_kefu {
    display: none;
    transition: all 0.3s linear 0s;
    width: 174px;
    height: 168px;
    background: url("~@/assets/images/zu474.png") no-repeat center;
    background-size: 100% 100%;
    position: absolute;
    top: 194px;
    left: -164px;
    text-align: left;
    > p {
      font-size: 12px;
      font-weight: 400;
      color: #333333;
      margin: 12px 0 0 12px;
    }
    .img {
      width: 24px;
      height: 24px;
    }
    > div {
      margin: 8px 0 0 12px;
      display: flex;
      .kefu {
        color: #333333;
        font-size: 16px;
        font-weight: 400;
        margin-left: 8px;
      }
    }
    .kfg {
      width: 142px;
      margin: 0 auto;
      border: 1px solid #cccccc;
      margin-top: 8px;
      margin-bottom: 8px;
    }
  }
}
</style>
<!-- <style>

#nb_icon_wrap{
    margin-top: 0px !important;
}
#newBridge .nb-frame-chat-box-right-bottom{
    right: 2px!important;
}
</style> -->


// WEBPACK FOOTER //
// src/components/rightContact.vue